import Vue from "vue";
import Router from "vue-router";
import BindingMember from "@/BindingMember/index";
import BindingMenmberCard from "@/BindingMenmberCard/index";
import consumptionRecord from "@/consumptionRecord/index";
import PaymentCode from "@/PaymentCode/index";
import exchange from "@/exchange/index";
import MemberOpen from "@/MemberOpen/index";
import CodeDetails from "@/CodeDetails/index";
import add from "@/add/index";
import Recharge from "@/Recharge/index";
import RechargeMp from "@/RechargeMp/index";
import Detail from "@/Detail";
import invest from "@/invest";
import myCoupon from "@/MyCoupon";
import Actives from "@/Actives";
import Registers from "@/Registers";
import ShopPay from "@/shopPay/index";
import Integral from "@/integralDetail/index";
import IntegralExchange from "@/integralExchange/index";
import Mall from "@/mall/index";
import Order from "@/order/index";
import AddAdress from "@/addAdress/index";
import MyOrder from "@/myOrder/index";
import OrderDetail from "@/orderDetail/index";
import PaySuccess from "@/paySuccess/index";
import PayError from "@/payError/index";
import RegisterByCode from "@/RegisterByCode/index";
import activeCenter from "@/activeCenter/index";
import PosterDetail from "@/posterdetail/index";
import WeixinBind from "@/weixinBind/index";
import Bindmp from "@/bindmp/index";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "add",
      component: add,
      meta: {
        title: "首页"
      }
    },
    {
      path: "/BindingMember",
      name: "BindingMember",
      component: BindingMember,
      meta: {
        title: "绑定会员卡"
      }
    },
    {
      path: "/MemberOpen",
      name: "MemberOpen",
      component: MemberOpen,
      meta: {
        title: "会员开卡"
      }
    },
    {
      path: "/BindingMenmberCard",
      name: "BindingMenmberCard",
      component: BindingMenmberCard,
      meta: {
        title: "微信会员卡"
      }
    },
    {
      path: "/consumptionRecord",
      name: "consumptionRecord",
      component: consumptionRecord,
      meta: {
        title: "消费记录"
      }
    },
    {
      path: "/PaymentCode",
      name: "PaymentCode",
      component: PaymentCode,
      meta: {
        title: "我要付款"
      }
    },
    {
      path: "/CodeDetails",
      name: "CodeDetails",
      component: CodeDetails,
      meta: {
        title: "我要付款"
      }
    },
    {
      path: "/exchange",
      name: "exchange",
      component: exchange,
      meta: {
        title: "积分兑换"
      }
    },
    {
      path: "/Recharge",
      name: "Recharge",
      component: Recharge,
      meta: {
        title: "我要充值"
      }
    },
    {
      path: "/RechargeMp",
      name: "RechargeMp",
      component: RechargeMp,
      meta: {
        title: "我要充值"
      }
    },

    {
      path: "/Detail",
      name: "Detail",
      component: Detail,
      meta: {
        title: "充值记录"
      }
    },
    {
      path: "/invest",
      name: "invest",
      component: invest,
      meta: {
        title: "充值"
      }
    },
    {
      path: "/activeCenter",
      name: "activeCenter",
      component: activeCenter,
      meta: {
        title: "活动中心"
      }
    },
    {
      path: "/myCoupon",
      name: "myCoupon",
      component: myCoupon,
      meta: {
        title: "我的卡券"
      }
    },
    {
      path: "/Actives",
      name: "Actives",
      component: Actives,
      meta: {
        title: "活动详情"
      }
    },
    {
      path: "/Registers",
      name: "Registers",
      component: Registers,
      meta: {
        title: "注册"
      }
    },
    {
      path: "/ShopPay",
      name: "ShopPay",
      component: ShopPay,
      meta: {
        title: "商户支付"
      }
    },
    {
      path: "/Integral",
      name: "Integral",
      component: Integral,
      meta: {
        title: "积分明细"
      }
    },
    {
      path: "/IntegralExchange",
      name: "IntegralExchange",
      component: IntegralExchange,
      meta: {
        title: "积分兑换"
      }
    },
    {
      path: "/Mall",
      name: "Mall",
      component: Mall,
      meta: {
        title: "商城"
      }
    },
    {
      path: "/Order",
      name: "Order",
      component: Order,
      meta: {
        title: "订单"
      }
    },
    {
      path: "/AddAdress",
      name: "AddAdress",
      component: AddAdress,
      meta: {
        title: "新增收货地址"
      }
    },
    {
      path: "/MyOrder",
      name: "MyOrder",
      component: MyOrder,
      meta: {
        title: "我的订单"
      }
    },
    {
      path: "/OrderDetail",
      name: "OrderDetail",
      component: OrderDetail,
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/PaySuccess",
      name: "PaySuccess",
      component: PaySuccess,
      meta: {
        title: "付款成功"
      }
    },
    {
      path: "/PayError",
      name: "PayError",
      component: PayError,
      meta: {
        title: "付款失败"
      }
    },
    {
      path: "/RegisterByCode",
      name: "RegisterByCode",
      component: RegisterByCode,
      meta: {
        title: "会员登录"
      }
    },
    {
      path: "/PosterDetail",
      name: "PosterDetail",
      component: PosterDetail,
      meta: {
        title: "海报详情"
      }
    },
    {
      path: "/weixinBind",
      name: "weixinBind",
      component: WeixinBind,
      meta: {
        title: "激活会员卡"
      }
    },
    {
      path: "/bindmp",
      name: "bindmp",
      component: Bindmp,
      meta: {
        title: "会员卡绑定"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js